import { ServicePriceResponseDto } from "../../models/ServicePriceResponseDto";
import { Routes } from "akademika/akamont/constants/Routes";
import { TariffPriceTableController } from "../sharedControllers/TariffPriceTableController";

/**
 * @namespace akademika.akamont.pages.priceDetailsOverview
 */
export default class PriceDetailsOverview extends TariffPriceTableController {
  route = Routes.PRICE_DETAILS_OVERVIEW;
  parentRoute = Routes.PRICE_LIST_OVERVIEW;

  public async onRouteMatched() {
    await this.fetchPriceDetailsData();
  }

  public async fetchPriceDetailsData() {
    const response = await this.fetchModel<ServicePriceResponseDto>(
      "api/ServicePrice/GetServicePrice/" + this.routeParams.servicePriceId,
      "servicePrice"
    );

    if (response) {
      this.refreshTariffIntervalTable(true);
    }
  }
}
